const TICKET_HOSTS = new Set(['liput.matkahuolto.fi', 'liputtest.matkahuolto.fi']);
const SUPPORTED_LANGUAGES = new Set(['fi', 'sv', 'en']);

export const contentfulText = (value) => {
  if (typeof value !== 'string') return null;
  const text = value.trim();
  return text || null;
};

export const localizeTicketLink = (link, locale) => {
  if (!link || !locale) return link;

  try {
    const url = new URL(link);
    const language = locale.toLowerCase().split('-')[0];

    if (!TICKET_HOSTS.has(url.hostname) || !SUPPORTED_LANGUAGES.has(language)) {
      return link;
    }

    url.searchParams.set('lang', language);
    return url.toString();
  } catch {
    return link;
  }
};
